import React from "react";
import { SVG } from "..";
import { SVG_ENUM } from "../../enums";
import "./ErrorMessage.scss";

interface ErrorMessageProps {
  message: string;
  isVisible: boolean;
  onClose?: () => void;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  isVisible,
  onClose,
  className = "",
}) => {
  if (!isVisible) return null;

  return (
    <p className={`error-message ${className}`}>
      {message}
      {onClose && (
        <span onClick={onClose} className="error-message__close">
          <SVG type={SVG_ENUM.CLOSE_CIRCLE} />
        </span>
      )}
    </p>
  );
};

export default ErrorMessage;
